export default __webpack_public_path__ + "static/media/PDF.66b4df9a.svg";